import React from "react";
import Proptypes from "prop-types";
import RevShareModal from "../../common/overrides/RevShareModal";
import { getQuarterHourBreakdownDetails } from "../../../apis/revshare/AvailableHoursApi";
import { Card, Form, Spinner, Table } from "react-bootstrap";
import PlainTextField from "../../common/forms/PlainTextField";

export default class QuarterHoursDetailModal extends React.Component {
  render() {
    return (
      <RevShareModal
        buttonText="Hour Breakdown"
        buttonVariant="secondary"
        hideYesButton
        noButtonText="close"
        title={`Hour Breakdown for ${this.props.quarter}`}
      >
        <Card>
          <Card.Header>Summary</Card.Header>
          <Card.Body>
            {this.state.loading ? (
              <Spinner animation="border" />
            ) : (
              <Form>
                <PlainTextField inline label="Total Hours Reported" value={this.state.summary.totalHoursReported} />
                <PlainTextField
                  inline
                  label="Billable Hours Reported"
                  value={this.state.summary.billableHoursReported}
                />
                <PlainTextField
                  inline
                  label="Nonbillable Hours Reported"
                  value={this.state.summary.nonBillableHoursReported}
                />
                <PlainTextField
                  inline
                  label="Utilization Exempt Hours Reported"
                  value={this.state.summary.nonBillableExemptHoursReported}
                />
                <PlainTextField
                  inline
                  label="Required Hours (After Exempt)"
                  value={this.state.summary.totalRequiredHours}
                />
                <PlainTextField inline label="Earnable Rev Share Hours" value={this.state.summary.earnableRevShare} />
                <PlainTextField
                  inline
                  label="Utilization Percentage"
                  value={`${(this.state.summary.utilization * 100).toFixed(2)}%`}
                />
              </Form>
            )}
          </Card.Body>
        </Card>

        {this.state.loading
          ? null
          : this.state.details.map((month) => (
              <Card key={month.month}>
                <Card.Header key={month.month + "_header"}>{monthName[month.month - 1]} - Projects</Card.Header>
                <Card.Body key={month.month + "_body"}>
                  <Form>
                    <PlainTextField inline label="Total Hours Reported" value={month.totalHoursReported} />
                    <PlainTextField inline label="Billable Hours Reported" value={month.billableHoursReported} />
                    <PlainTextField inline label="Nonbillable Hours Reported" value={month.nonBillableHoursReported} />
                    <PlainTextField
                      inline
                      label="Utilization Exempt Hours Reported"
                      value={month.nonBillableExemptHoursReported}
                    />
                    <PlainTextField inline label="Required Hours (After Exempt)" value={month.requiredHours} />
                    <PlainTextField inline label="Earnable Rev Share Hours" value={month.earnableRevShare} />
                  </Form>
                  <Table key={month.month + "_table"}>
                    <thead key={month.month + "_table_thead"}>
                      <tr key={`${this.props.availableHoursId}_${month.month}_headers`}>
                        <th>Project</th>
                        <th>Task</th>
                        <th>Billable</th>
                        <th>Hours</th>
                        <th>Rev Share Eligible</th>
                      </tr>
                    </thead>
                    <tbody key={month.month + "_table_tbody"}>
                      {month.projects.map((project) => (
                        <tr
                          key={`${this.props.availableHoursId}_${month.month}_${project.projectCode}_${project.taskName}`}
                        >
                          <td>{project.projectCode}</td>
                          <td>{project.taskName}</td>
                          <td>{project.isBillableProject ? "Yes" : "No"}</td>
                          <td>{project.hours}</td>
                          <td>{project.isRevShareEliganbleProject && project.taskName !== "900" ? "Yes" : "No"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            ))}
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      summary: null,
      details: null,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    getQuarterHourBreakdownDetails(this.props.availableHoursId).then((i) => {
      if (this._isMounted) {
        this.setState({ loading: false, summary: i.summary, details: i.monthDetails });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
}

const monthName = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

QuarterHoursDetailModal.propTypes = {
  availableHoursId: Proptypes.number.isRequired,
  quarter: Proptypes.string.isRequired,
};
